<template lang="pug">
.dashboard-card
  .section-header
    .section-title
      h2 Mis cursos
      p Capacitaciones y cursos asignados
  .empty-state(v-if="lista.length === 0")
    .empty-info
      strong No tienes Cursos Asignados
  .courses(
    ref="courses"
    @scroll="handleScroll"
  )
    .course(
      v-for="curso in lista"
      :key="curso.id"
    )
      .course-heading
        .course-main
          strong
            | {{ curso.titulo }}

          .course-meta
            span {{ curso.NumeroClases }} clase(s)
            span.separator
              | •
            span {{ curso.DuracionTotal }}

        span.status(
          :class="{ completed: curso.progreso === 100 }"
        )
          | {{ curso.progreso === 100 ? 'Completado' : 'Pendiente' }}

      .progress-header
        span Progreso
        strong
          | {{ curso.progreso }}%

      .progress-bar
        .progress-value(
          :style="{ width: curso.progreso + '%' }"
        )

      button.course-action(
        @click="continuar(curso.id)"
      )
        | {{ curso.progreso > 0 ? 'Continuar curso' : 'Comenzar curso' }}
        span
          | →
</template>
<script>
import { apiGet, notify }  from '../../../util/general'
import moment from 'moment';
export default {
  name: 'MisCursos',
  data () {
    return {
      lista                                 : [],
      mes                                   : moment().month() + 1,
      isLoading                             : false,
      disabledScrollExecute                 : false,
      noMore                                : false,
      isScroll                              : false,
      numeroRecnum                                  : 0
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    handleScroll (event) {
      var vm = this
      var element = event.target

      if (
        vm.isLoading ||
        vm.isScroll ||
        vm.noMore ||
        vm.disabledScrollExecute
      ) {
        return
      }

      var scrollTop = element.scrollTop
      var scrollHeight = element.scrollHeight
      var clientHeight = element.clientHeight

      var distanciaFinal = scrollHeight - (scrollTop + clientHeight)

      console.log('scrollTop >>>', scrollTop)
      console.log('scrollHeight >>>', scrollHeight)
      console.log('clientHeight >>>', clientHeight)
      console.log('distanciaFinal >>>', distanciaFinal)

      if (distanciaFinal <= 80) {
        vm.cargarMas()
      }
    },

    fetch () {
      var vm = this

      vm.lista = []
      vm.numeroRecnum = 0
      vm.noMore = false
      vm.isLoading = true

      vm.obtenerCursos()
    },

    cargarMas () {
      var vm = this

      if (
        vm.noMore ||
        vm.disabledScrollExecute ||
        vm.isScroll
      ) {
        return
      }

      vm.isScroll = true

      vm.obtenerCursos()
    },

    obtenerCursos () {
      var vm = this

      if (vm.noMore || vm.disabledScrollExecute) {
        return
      }

      vm.disabledScrollExecute = true

      var obj = {
        numeroRecnum: vm.numeroRecnum
      }

      console.log(
        'Consultando cursos numeroRecnum >>>',
        vm.numeroRecnum
      )

      apiGet(
        vm,
        '/curso/virtual/alumno/lista',
        obj,

        function (data) {
          var lista = data && data.lista
            ? data.lista
            : []

          console.log('Cursos recibidos >>>', lista)
          console.log('noMore >>>', data.noMore)

          for (var i = 0; i < lista.length; i++) {
            vm.lista.push(lista[i])
          }

          vm.numeroRecnum += lista.length

          if (data.noMore || lista.length === 0) {
            vm.noMore = true
          }

          vm.disabledScrollExecute = false

          /*
          * Esperamos a que Vue renderice los nuevos cursos.
          */
          vm.$nextTick(function () {
            vm.verificarScroll()
          })
        },

        function (error) {
          vm.disabledScrollExecute = false

          notify(
            vm,
            'error',
            'Error',
            error.message
          )
        },

        function () {
          vm.isLoading = false
          vm.isScroll = false
        }
      )
    },

    verificarScroll () {
      var vm = this

      if (vm.noMore) {
        return
      }

      vm.$nextTick(function () {
        var element = vm.$refs.courses

        if (!element) {
          return
        }

        console.log(
          'scrollHeight >>>',
          element.scrollHeight
        )

        console.log(
          'clientHeight >>>',
          element.clientHeight
        )

        /*
        * Si todavía NO existe scroll,
        * solicitamos automáticamente otra página.
        */
        if (element.scrollHeight <= element.clientHeight) {
          vm.cargarMas()
        }
      })
    },

    estado (avance) {
      if (avance === 100) {
        return 'Completado'
      }

      if (avance >= 50) {
        return 'En progreso'
      }

      return 'Pendiente'
    },

    estadoClass (avance) {
      if (avance === 100) {
        return 'verde'
      }

      if (avance >= 50) {
        return 'amarillo'
      }

      return 'rojo'
    },

    continuar (id) {
      var vm = this

      vm.$router.push(
        '/mis-cursos/' + id + '/clases'
      )
    }
  }
}
</script>
<style scoped>
.dashboard-card {
  width: 100%;
  background: white;
  border: 1px solid #e1e4e8;
  border-radius: 10px;
  overflow: hidden;
  box-sizing: border-box;
}
.section-header {
  margin-bottom: 17px;
}
.section-title h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #292d32;
}
.section-title p {
  margin: 4px 0 0;
  font-size: 12px;
  color: #8b9097;
}
.card-header {
  min-height: 68px;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eff0f2;
}
.card-title h3 {
  margin: 0;
  font-size: 15px;
  color: #292d32;
}
.card-title p {
  margin: 4px 0 0;
  font-size: 11px;
  color: #92979e;
}
.course-count {
  min-width: 27px;
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f1e9ef;
  color: #714b67;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
}

.course {
  padding: 20px 22px;

  background: #fff;

  border-right: 1px solid #eff0f2;
  border-bottom: 1px solid #eff0f2;
}
.course:last-child {
  border-bottom: 0;
}
.course-heading {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
.course-main {
  flex: 1;
}
.course-main strong {
  display: block;
  color: #363a3f;
  font-size: 12px;
  line-height: 1.45;
}
.course-meta {
  margin-top: 5px;
  display: flex;
  align-items: center;
  gap: 7px;
  color: #969ba1;
  font-size: 10px;
}
.separator {
  color: #cacdd1;
}
.status {
  height: fit-content;
  padding: 4px 8px;
  border-radius: 15px;
  background: #fff4e5;
  color: #c67b0c;
  font-size: 9px;
  font-weight: 600;
}
.status.completed {
  background: #eaf7ee;
  color: #43835a;
}
.progress-header {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  color: #84898f;
}
.progress-header strong {
  color: #714b67;
}
.progress-bar {
  width: 100%;
  height: 5px;
  margin-top: 7px;
  background: #ececef;
  border-radius: 5px;
  overflow: hidden;
}
.progress-value {
  height: 100%;
  background: #714b67;
  border-radius: 5px;
  transition: width .3s ease;
}
.course-action {
  margin-top: 15px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #714b67;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
}
.course-action span {
  margin-left: 4px;
  transition: margin-left .15s;
}
.course-action:hover span {
  margin-left: 8px;
}
@media (max-width: 900px) {

  .courses {
    grid-template-columns: 1fr;
  }

}
.empty-state {
  min-height: 245px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 25px;
}
.courses-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  width: 100%;
}

.course {
  position: relative;

  min-width: 0;
  min-height: 150px;

  padding: 22px;

  background: #fff;

  box-sizing: border-box;

  border-bottom: 1px solid #d9dde3;
}

/* Separador vertical */
.course:nth-child(odd) {
  border-right: 1px solid #d9dde3;
}

/* Efecto cuando pasa el mouse */
.course:hover {
  background: #fafbfc;
}
.courses {
  display: grid;

  grid-template-columns:
    repeat(2, minmax(0, 1fr));

  background: #f9fafb;

  gap: 1px;

  height: 320px;

  overflow-y: auto;
  overflow-x: hidden;
}
.courses::-webkit-scrollbar {
  width: 6px;
}

.courses::-webkit-scrollbar-track {
  background: #f5f5f5;
}

.courses::-webkit-scrollbar-thumb {
  background: #c7cbd1;
  border-radius: 10px;
}

.courses::-webkit-scrollbar-thumb:hover {
  background: #aeb3ba;
}
</style>



// WEBPACK FOOTER //
// c_mis_cursos.vue?dde56afe